var ratingsCompDayPartInputInit = function(){
    $('#form_day_part_start').wickedpicker({
        now: "18:00",
        minutesInterval: 15
    }).click(function () {
        $('.white-box').click();
        $(this).focus();
        $('.wickedpicker').css({
            'z-index': $(this).css('z-index') + 1,
            position: 'absolute',
            left: $(this).offset().left,
            top: $(this).top + $('.wickedpicker').height() + 5
        });
        $('#form_day_part_end').attr('aria-showingpicker', false);
        $('#form_day_part_start').attr('tabindex', 0);
        $('#form_day_part_start').attr('aria-showingpicker', true);
        $('#form_day_part_start').attr('tabindex', -1);

    });

    $('#form_day_part_end').wickedpicker({
        now: "19:00",
        minutesInterval: 15
    }).click(function () {
        $('.white-box').click();
        $(this).focus();
        $('.wickedpicker').css({
            'z-index': $(this).css('z-index') + 1,
            position: 'absolute',
            left: $(this).offset().left,
            top: $(this).top + $('.wickedpicker').height() + 5
        });
        $('#form_day_part_start').attr('aria-showingpicker', false);
        $('#form_day_part_end').attr('tabindex', 0);
        $('#form_day_part_end').attr('aria-showingpicker', true);
        $('#form_day_part_end').attr('tabindex', -1);

    });

    $('.day_part_select button').bind('click', function(index, value){
        if ($(this).hasClass('btn-default')) {
            $(this).removeClass('btn-default').addClass('btn-primary');
        } else {
            $(this).addClass('btn-default').removeClass('btn-primary');
        }

        compSetDaysInput(this);
    });
};

var compSetDaysInput = function (button) {
    var container = $(button).closest('.day_part_select');
    var input = container.find('input');
    var buttons = container.find('button');

    var html = '';

    $.each(buttons, function (index, value) {
        if ($(value).hasClass('btn-primary')) {
            $(value).html($(value).attr('data-value'));
            html += $(value).attr('data-value');
        } else {
            $(value).html('-');
            html += '-';
        }
    });

    $(input).val(html);
};

var ratingsHumanDaypart = function(day_part){
    dp_start = day_part.substring(7, 11);
    dp_end = day_part.substring(11, 15);

    dp_start = moment(dp_start, 'HHmm');
    dp_end = moment(dp_end, 'HHmm');

    return day_part.substring(0, 7) + ' ' + dp_start.format('h:mm A') + ' to ' + dp_end.format('h:mm A');
};